<ng-container *transloco="let t">
<ng-template #pricing>

  <div class="row pricing-layout" style="margin: 0 auto;">
    <div class="card shadow-sm col-12 col-lg me-lg-2 mb-3 mb-lg-0 non-price-panel">
      <div class="card-header px-4 d-flex align-items-center justify-content-between border-bottom-2">
        <h4 class="mb-0">
          {{ t('wizard.pricing.liabilitiesToPayOff') }}
        </h4>
      </div>
      <div class="mt-4">
        @for (liability of activeLiabilities; track liability.liabilityId) {
          <liability-card (liabilityChanged)="onLiabilityChanged($event)"
            [liability]="liability">
          </liability-card>
        }
      </div>
    </div>
    <div class="card shadow-sm col-12 col-lg me-lg-2 mb-3 mb-lg-0 price-panel">
      <div class="d-flex flex-column flex-sm-row justify-content-between">
        <div class="flex-grow-1 mb-6 mb-sm-10 text-center">
          <label class="fs-6 fw-bold form-label mt-3">
            {{ t('wizard.pricing.loanAmount') }}
          </label>
          <span id="loan-amount-width-calculator" [hidden]="true">{{loanAmount}}</span>
          <input id="loan-amount" type="text" class="form-control loan-amount-editor"
            mask="separator"
            thousandSeparator="," inputmode="decimal" prefix="$" [(ngModel)]="loanAmount" placeholder=""
            name="loanAmount" (blur)="onLoanAmountChanged()" (keyup)="onKeyUpOnLoanAmount()" />
          <div style="width: 60%; margin: 0 auto">
            <p-slider [step]="1000" [min]="minLoanAmount" [max]="maxLoanAmount" [(ngModel)]="loanAmount"
              (onSlideEnd)="onLoanAmountChanged()">
            </p-slider>
          </div>
        </div>
        <div class="flex-grow-1 mb-6 mb-sm-10 text-center">
          <label class="fs-6 fw-bold form-label mt-3">
            {{ t('wizard.pricing.loanTerm') }}
          </label>
          <span id="loan-term-width-calculator" [hidden]="true">{{loanAmount}}</span>
          <input id="loan-term" type="text" class="form-control loan-term-editor"
            inputmode="number" [(ngModel)]="loanTerm" placeholder=""
            name="loanTerm" />
          <div style="width: 60%; margin: 0 auto">
            <p-slider [step]="5" [min]="5" [max]="30" [(ngModel)]="loanTerm"
              (onSlideEnd)="onLoanTermChanged()">
            </p-slider>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center flex-wrap">
        @if (liabilityPayOffInformationChanged && productSearchResults?.products) {
          <div class="text-center shadow-sm liability-payoff-info-body">
            <h4> {{ t('wizard.pricing.modifiedDebtsMessage') }} </h4>
            <h4 class="mt-8"> {{ t('wizard.pricing.clickToUpdatePricing') }} </h4>
            <button type="button" class="btn btn-primary" style="margin-top: 4rem;" (click)="onRefreshPricingClicked()">
              {{ t('wizard.pricing.refreshPricing') }} </button>
          </div>
        }
        @for (product of productSearchResults?.products | filter : 'isEligible'; track product.productId) {
          <div class="mb-2" style="max-width: 350px;">
            <product-price-card [loanAmount]="productSearchRequest.loanInformation.baseLoanAmount"
              [liabilityPayOffInformationChanged]="liabilityPayOffInformationChanged"
              [appraisedValue]="productSearchRequest.propertyInformation.appraisedValue" [product]="product"
              (rateEditClicked)="onRateEditClicked($event)"
              [isSelected]="selectedPricingProduct && product.productId === selectedPricingProduct.productId"
              (selectedCardChanged)="onSelectedCardChanged($event)">
            </product-price-card>
          </div>
        }
        @if (!productSearchResults?.products || ((productSearchResults?.products | filter : 'isEligible').length === 0) || inEditMode) {
          <div>
            <div class="alert bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10">
              <div class="d-flex flex-column pe-0">
                @if (!inEditMode) {
                  <h4 class="fw-semibold">{{step.noProductFoundMessageTitle}}</h4>
                } @else {
                  <input [name]="'no-product-message-title'" type="text"
                    class="form-control form-control-solid fs-4 fw-bolder" [(ngModel)]="step.noProductFoundMessageTitle" />
                }
                @if (!inEditMode) {
                  <span>{{step.noProductsFoundMessageText}}</span>
                } @else {
                  <input [name]="'no-product-message-text'" type="text"
                    class="form-control form-control-solid fs-4 fw-bolder" [(ngModel)]="step.noProductsFoundMessageText" />
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="card shadow-sm col-12 col-lg non-price-panel benefits-panel">
      <div class="card-header px-4 d-flex align-items-center justify-content-between border-bottom-2">
        <h4 class="mb-0">
          {{ t('wizard.pricing.benefits') }}
        </h4>
      </div>
      <div class="mt-4">
        <benefits [liabilitiesToPayOff]="liabilitiesToPayOff" [loanAmount]="loanAmount"
          [product]="selectedPricingProduct">
        </benefits>
      </div>
    </div>
  </div>

</ng-template>

<wizard-step-template [stepMainTemplate]="pricing" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
